import { AxiosResponse } from 'axios';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import SingleValueResponse from '../../../infrastructure/types/common/SingleValueResponse';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';

const getCurrentVersion = (id: number): Promise<AxiosResponse<SingleValueResponse<string>>> => {

    let route = urlHelper.buildRoute(['report', id, 'version']);

    return httpClient.get<SingleValueResponse<string>>(route);
};

const getUserIdRequestedApproval = async (userId: number): Promise<string> => {

    let route = urlHelper.buildRoute(['report-version', userId, 'get-user-requested-approval']);

    let response = await httpClient.getWithAsyncAwait(route);

    return response.data;
};

const noApproveCommentMessage = 'Please add a comment.';

const requestForReleaseApprovalMessage = 'There is a request for release approval.';

const getReleaseConfigMessage =(name:string)=> `You are going to release config name ${name}. Please note, if this CB config is used by TRConnect then releasing this config will impact LIVE reporting. Do you want proceed?`;

export { getCurrentVersion, getUserIdRequestedApproval, getReleaseConfigMessage, noApproveCommentMessage, requestForReleaseApprovalMessage };
